import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useApp } from 'common/context';

const Logout = props => {

    const { logout } = useApp();
    const history = useHistory();

    useEffect(() => {

        // Do logout
        logout();

        // Redirect
        history.push("/");

    }, []);

    return (
        <></>
    );

};

export default Logout;
